"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickbooksApiMethods = exports.IntegrationsQuickbooksSyncStatus = exports.IntegrationsQuickbooksAuthStatus = void 0;
var IntegrationsQuickbooksAuthStatus;
(function (IntegrationsQuickbooksAuthStatus) {
    IntegrationsQuickbooksAuthStatus["NeverConnected"] = "NeverConnected";
    IntegrationsQuickbooksAuthStatus["Connected"] = "Connected";
    IntegrationsQuickbooksAuthStatus["RetryingConnection"] = "RetryingConnection";
    IntegrationsQuickbooksAuthStatus["Disconnected"] = "Disconnected";
})(IntegrationsQuickbooksAuthStatus = exports.IntegrationsQuickbooksAuthStatus || (exports.IntegrationsQuickbooksAuthStatus = {}));
var IntegrationsQuickbooksSyncStatus;
(function (IntegrationsQuickbooksSyncStatus) {
    IntegrationsQuickbooksSyncStatus["NeverSynced"] = "NeverSynced";
    IntegrationsQuickbooksSyncStatus["PendingSync"] = "PendingSync";
    IntegrationsQuickbooksSyncStatus["Synced"] = "Synced";
    IntegrationsQuickbooksSyncStatus["OutOfSync"] = "OutOfSync";
})(IntegrationsQuickbooksSyncStatus = exports.IntegrationsQuickbooksSyncStatus || (exports.IntegrationsQuickbooksSyncStatus = {}));
var QuickbooksApiMethods;
(function (QuickbooksApiMethods) {
    QuickbooksApiMethods["POST"] = "POST";
    QuickbooksApiMethods["GET"] = "GET";
    QuickbooksApiMethods["DELETE"] = "DELETE";
})(QuickbooksApiMethods = exports.QuickbooksApiMethods || (exports.QuickbooksApiMethods = {}));
//# sourceMappingURL=integrationsQuickbooks.js.map